module.exports = __webpack_public_path__ + "static/media/logo_high_res.92bbb5f7.png";